import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'portal.vies.FNOLWizard.PageTitle',
        defaultMessage: 'Report new claim'
    },
    missingPolicySelectedErrorTitleMsg: {
        id: 'ax.fnol.policysearch.MissingPolicySelected.Title',
        defaultMessage: 'Missing policy'
    },
    missingPolicySelectedErrorBodyMsg: {
        id: 'ax.fnol.policysearch.MissingPolicySelected.Body',
        defaultMessage: 'You must select a policy before going to step 2'
    },
    invalidClaimLossDateTitleMsg: {
        id: 'ax.fnol.policysearch.InvalidLossDate.Title',
        defaultMessage: 'Invalid Loss date'
    },
    invalidClaimLossDateBodyMsg: {
        id: 'ax.fnol.policysearch.InvalidLossDate.Body',
        defaultMessage: 'Loss date is required, and must be in the range of the selected policy period and not in the future'
    },
    noAssistanceCoverageError: {
        id: 'portal.views.dashboard-table.new-claim-report.noAssistanceCoverageError_AX',
        defaultMessage: 'Unable to submit claim report'
    },
    noAssistanceCoverageErrorMessage: {
        id: 'portal.views.dashboard-table.new-claim-report.noAssistanceCoverageErrorMessage_AX',
        defaultMessage: 'This policy does not cover the coverage "Assistance Services"'
    },
    invalidSendClaimTitle: {
        id: 'ax.fnol.send.Claim.title',
        defaultMessage: 'Error'
    },
    invalidSendClaim: {
        id: 'ax.fnol.send.claim.body',
        defaultMessage: 'Correctly enter all the fields before saving the claim'
    },
    invalidAssistance: {
        id: 'ax.claim.directive.policy.Message',
        defaultMessage: 'You dont have assistance avaliables'
    }
});
